// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Общий стиль страницы */
.roles-permissions-page {
    padding: 20px;
    font-family: Arial, sans-serif;
    background-color: #f7f7f7;
    min-height: 100vh;
    color: #333;
  }
  
  .roles-permissions-page h1 {
    text-align: center;
    margin-bottom: 20px;
  }
  
  /* Контейнер для боковой панели и основного содержимого */
  .content-wrapper {
    display: flex;
    gap: 20px;
  }
  
  /* Стили для боковой панели (список ролей) */
  .roles-sidebar {
    width: 250px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 15px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  
  .roles-sidebar h2 {
    margin-top: 0;
    font-size: 20px;
    color: #007bff;
  }
  
  .roles-list {
    list-style: none;
    padding: 0;
    margin: 0 0 15px 0;
  }
  
  .role-item {
    padding: 8px 10px;
    cursor: pointer;
    border-bottom: 1px solid #eee;
    transition: background-color 0.3s;
  }
  
  .role-item:hover {
    background-color: #f0f0f0;
  }
  
  .role-item.active {
    background-color: #007bff;
    color: #fff;
  }
  
  /* Основная область для управления правами */
  .permissions-main {
    flex: 1 1;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 15px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  
  .permissions-main h2 {
    margin-top: 0;
    color: #007bff;
  }
  
  /* Двухколоночный макет для списков прав */
  .dual-list-container {
    display: flex;
    gap: 20px;
    margin-top: 15px;
  }
  
  .list-column {
    flex: 1 1;
    background-color: #f9f9f9;
    border: 1px solid #eee;
    border-radius: 4px;
    padding: 10px;
    max-height: 400px;
    overflow-y: auto;
  }
  
  .list-column h3 {
    margin-top: 0;
    font-size: 16px;
    color: #333;
  }
  
  .permissions-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .permission-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 8px;
    border-bottom: 1px solid #ddd;
  }
  
  .permission-item button {
    background-color: #28a745;
    color: #fff;
    border: none;
    padding: 4px 8px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    transition: background-color 0.3s;
  }
  
  .permission-item button:hover {
    background-color: #218838;
  }
  
  /* Кнопки создания */
  .create-button {
    background-color: #007bff;
    color: #fff;
    border: none;
    padding: 8px 15px;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 15px;
    transition: background-color 0.3s;
  }
  
  .create-button:hover {
    background-color: #0056b3;
  }
  
  /* Модальные стили */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-container {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    width: 100%;
    max-width: 500px;
    box-shadow: 0 4px 10px rgba(0,0,0,0.2);
  }
  
  .modal-input {
    width: 100%;
    padding: 8px;
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  .modal-buttons {
    display: flex;
    justify-content: space-between;
  }
  
  .modal-btn {
    padding: 8px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .modal-save-btn {
    background-color: #4caf50;
    color: #fff;
  }
  
  .modal-cancel-btn {
    background-color: #f44336;
    color: #fff;
  }
  
  .modal-error {
    color: #f44336;
    margin-bottom: 10px;
  }
  `, "",{"version":3,"sources":["webpack://./src/modules/Admin/AdminPanelExample/Pages/RolesAndPermissionsPage.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA,yDAAyD;EACzD;IACE,aAAa;IACb,SAAS;EACX;;EAEA,4CAA4C;EAC5C;IACE,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,wCAAwC;EAC1C;;EAEA;IACE,aAAa;IACb,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,6BAA6B;IAC7B,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA,4CAA4C;EAC5C;IACE,SAAO;IACP,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,wCAAwC;EAC1C;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA,0CAA0C;EAC1C;IACE,aAAa;IACb,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,oBAAoB;EACpB;IACE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,oBAAoB;EACpB;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,sCAAsC;EACxC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB","sourcesContent":["/* Общий стиль страницы */\r\n.roles-permissions-page {\r\n    padding: 20px;\r\n    font-family: Arial, sans-serif;\r\n    background-color: #f7f7f7;\r\n    min-height: 100vh;\r\n    color: #333;\r\n  }\r\n  \r\n  .roles-permissions-page h1 {\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  /* Контейнер для боковой панели и основного содержимого */\r\n  .content-wrapper {\r\n    display: flex;\r\n    gap: 20px;\r\n  }\r\n  \r\n  /* Стили для боковой панели (список ролей) */\r\n  .roles-sidebar {\r\n    width: 250px;\r\n    background-color: #fff;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    padding: 15px;\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .roles-sidebar h2 {\r\n    margin-top: 0;\r\n    font-size: 20px;\r\n    color: #007bff;\r\n  }\r\n  \r\n  .roles-list {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0 0 15px 0;\r\n  }\r\n  \r\n  .role-item {\r\n    padding: 8px 10px;\r\n    cursor: pointer;\r\n    border-bottom: 1px solid #eee;\r\n    transition: background-color 0.3s;\r\n  }\r\n  \r\n  .role-item:hover {\r\n    background-color: #f0f0f0;\r\n  }\r\n  \r\n  .role-item.active {\r\n    background-color: #007bff;\r\n    color: #fff;\r\n  }\r\n  \r\n  /* Основная область для управления правами */\r\n  .permissions-main {\r\n    flex: 1;\r\n    background-color: #fff;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    padding: 15px;\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .permissions-main h2 {\r\n    margin-top: 0;\r\n    color: #007bff;\r\n  }\r\n  \r\n  /* Двухколоночный макет для списков прав */\r\n  .dual-list-container {\r\n    display: flex;\r\n    gap: 20px;\r\n    margin-top: 15px;\r\n  }\r\n  \r\n  .list-column {\r\n    flex: 1;\r\n    background-color: #f9f9f9;\r\n    border: 1px solid #eee;\r\n    border-radius: 4px;\r\n    padding: 10px;\r\n    max-height: 400px;\r\n    overflow-y: auto;\r\n  }\r\n  \r\n  .list-column h3 {\r\n    margin-top: 0;\r\n    font-size: 16px;\r\n    color: #333;\r\n  }\r\n  \r\n  .permissions-list {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n  }\r\n  \r\n  .permission-item {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 6px 8px;\r\n    border-bottom: 1px solid #ddd;\r\n  }\r\n  \r\n  .permission-item button {\r\n    background-color: #28a745;\r\n    color: #fff;\r\n    border: none;\r\n    padding: 4px 8px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n    transition: background-color 0.3s;\r\n  }\r\n  \r\n  .permission-item button:hover {\r\n    background-color: #218838;\r\n  }\r\n  \r\n  /* Кнопки создания */\r\n  .create-button {\r\n    background-color: #007bff;\r\n    color: #fff;\r\n    border: none;\r\n    padding: 8px 15px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    margin-top: 15px;\r\n    transition: background-color 0.3s;\r\n  }\r\n  \r\n  .create-button:hover {\r\n    background-color: #0056b3;\r\n  }\r\n  \r\n  /* Модальные стили */\r\n  .modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0,0,0,0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .modal-container {\r\n    background-color: #fff;\r\n    padding: 20px;\r\n    border-radius: 8px;\r\n    width: 100%;\r\n    max-width: 500px;\r\n    box-shadow: 0 4px 10px rgba(0,0,0,0.2);\r\n  }\r\n  \r\n  .modal-input {\r\n    width: 100%;\r\n    padding: 8px;\r\n    margin-bottom: 10px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .modal-buttons {\r\n    display: flex;\r\n    justify-content: space-between;\r\n  }\r\n  \r\n  .modal-btn {\r\n    padding: 8px 12px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .modal-save-btn {\r\n    background-color: #4caf50;\r\n    color: #fff;\r\n  }\r\n  \r\n  .modal-cancel-btn {\r\n    background-color: #f44336;\r\n    color: #fff;\r\n  }\r\n  \r\n  .modal-error {\r\n    color: #f44336;\r\n    margin-bottom: 10px;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
